var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBeemgIconsReply2023(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#333333;}\r\n\t.st1{fill:#C60505;}\r\n\t.st2{fill:#FF8500;}\r\n\t.st3{fill:#BF2B2B;}\r\n\t.st4{fill:#FFFFFF;}\r\n\t.st5{fill:#383838;}\r\n\t.st6{fill:#FFC200;}\r\n\t.st7{fill:#C41E1E;}\r\n\t.st8{fill:none;}\r\n\t.st9{fill:#98C437;}\r\n\t.st10{fill:#AFAFAF;}\r\n\t.st11{fill:#282828;}\r\n\t.st12{fill:#CECECE;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M29.58,25.84c-0.21,0-0.4-0.13-0.47-0.32c-0.1-0.26-2.59-6.47-10.84-6.47h-4.02v4.59 c0,0.19-0.11,0.37-0.28,0.45c-0.17,0.09-0.38,0.07-0.53-0.05L2.12,15.56c-0.13-0.1-0.2-0.24-0.2-0.4s0.08-0.31,0.2-0.4l11.31-8.49 c0.15-0.11,0.36-0.13,0.53-0.05c0.17,0.09,0.28,0.26,0.28,0.45v4.59h2.89c7.75,0,12.95,5.66,12.95,14.08c0,0.24-0.17,0.45-0.41,0.5 C29.64,25.84,29.61,25.84,29.58,25.84z M13.74,18.04h4.53c5.95,0,9.18,3.1,10.69,5.21c-0.78-6.65-5.33-10.99-11.82-10.99h-3.39 c-0.28,0-0.5-0.23-0.5-0.5V7.68l-9.97,7.48l9.97,7.48v-4.08C13.23,18.27,13.46,18.04,13.74,18.04z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeemgIconsReply2023);
export default __webpack_public_path__ + "static/media/beemg-icons-reply-2023.1b425206a47cccc7b0ec4234f998c407.svg";
export { ForwardRef as ReactComponent };